import React, { type ReactElement } from 'react';
import Alert from 'atom-components/alert';
import Card from 'atom-components/card';
import { friendlyAutoscoredComment } from 'helpers/domain-specific/autoscored-mark.helpers';
import { type TestInstanceResponseMarkWithItems } from 'services/assist-api/entities/test-instance-response-mark/types';

type Props = {
  mark: TestInstanceResponseMarkWithItems;
};

export default function AutoscoringIssues({ mark }: Props): ReactElement {
  return (
    <Card>
      <Card.Header>
        <Card.Heading level={3}>Autoscoring Issues</Card.Heading>
      </Card.Header>
      <Card.Body>
        <Alert
          className="mb-0 pb-0"
          variant={mark.replacementTestInstanceResponseMark ? 'success' : 'danger'}
        >
          {mark.comment ? (
            <>
              <p>The following issue was found during automatic scoring of this response:</p>
              <p>
                <b>{friendlyAutoscoredComment(mark.comment)}</b>
              </p>
              {mark.replacementTestInstanceResponseMark && (
                <p>
                  Since this autoscored mark has been replaced by a manual mark, this does not
                  require your attention.
                </p>
              )}
            </>
          ) : (
            <p>
              There are currently no issues identified from autoscored marking that require your
              attention.
            </p>
          )}
        </Alert>
      </Card.Body>
    </Card>
  );
}
